import { errorHandlingSwrOptions } from '@ori/checkout-utils';
import {
  type StaticApplicationsMiniBagConfigurationDto,
  useGetTenantApplicationsMiniBagConfiguration,
} from '@ori/static-api-client-react';

import { logInfo } from '../logger';
import type { ClientAppConfig } from '../types';

const hookName = 'useGetApiConfigurationData';

export function useGetApiConfigurationData({ tenant }: Pick<ClientAppConfig, 'tenant'>) {
  const swrOptions = {
    ...errorHandlingSwrOptions,
    onSuccess: (data: StaticApplicationsMiniBagConfigurationDto) => {
      logInfo(`${hookName} hook: Part of configuration was loaded via static API.`, data);
    },
  };

  const { data, isValidating } = useGetTenantApplicationsMiniBagConfiguration(tenant, {
    swr: swrOptions,
  });

  return {
    apiConfiguration: data,
    isApiConfigurationLoading: isValidating,
  };
}
